import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconRemoveKeyframe: React.FC<CentralIconBaseProps> = (props) => {
  return (
    <CentralIconBase {...props} ariaLabel="remove-keyframe, rhombus">
      <path
        d="M12 2.5L2.5 12L12 21.5L21.5 12L12 2.5Z"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M10 12H14"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="square"
      />
    </CentralIconBase>
  );
};

export default IconRemoveKeyframe;
